module.exports = __webpack_public_path__ + "img/frame (127).83dfb2f7.jpg";